/**
 * Generated by orval 🍺
 * Do not edit manually.
 * React Admin API
 * OpenAPI spec version: 1.0.0
 */

import { openApiRequest } from '../openapi';
import type { CurrentUserResponse, NoticeIconList } from './model';

export const getCurrentUserUrl = () => {
  return `/api/currentUser`;
};

/**
 * 获取当前用户
 */
export const currentUser = async (
  options?: Parameters<typeof openApiRequest>[1],
): Promise<CurrentUserResponse> => {
  return openApiRequest<CurrentUserResponse>(getCurrentUserUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetNoticesUrl = () => {
  return `/api/notices`;
};

/**
 * 获取通知
 */
export const getNotices = async (
  options?: Parameters<typeof openApiRequest>[1],
): Promise<NoticeIconList> => {
  return openApiRequest<NoticeIconList>(getGetNoticesUrl(), {
    ...options,
    method: 'GET',
  });
};
